/**
 * 获取支付方式工具类
 *
 * @author caixinfeng
 * @site https://pay.poa.ai
 * @date 2021/5/8 07:18
 */

import config from '@/config'

const getToPageRouteName = function () {
    const payWay = getPayWay();
    return  payWay ? payWay.routeName : null
}

const getPayWay = function () {
    console.log(navigator.userAgent);
    const userAgent = navigator.userAgent;

    if(userAgent.indexOf("MicroMessenger") >= 0){
        return config.payWay.WXPAY;
    }

    // if(userAgent.indexOf("AlipayClient") >= 0 || userAgent.indexOf("AlipayConnect") >= 0){
    if(userAgent.indexOf("Alipay") >= 0 || userAgent.indexOf("KAKAOTALK") >= 0 || userAgent.indexOf("PAYAPP") >= 0){
        return config.payWay.ALIPAYPLUS;
    }

    return null;

}

export default {
    getToPageRouteName: getToPageRouteName,
    getPayWay: getPayWay
}
